export default "__VITE_ASSET__CNzzN9bk__"